
import $ from 'jquery';

import {getViewControllerName} from './../general/Util.js';

export class AlternativeProductPerSize {

	constructor( containerEl ) {
		this.containerEl = containerEl;
		let popupHeadingInitialText = false;

		this.containerEl.addEventListener( 'click', ( ev ) => {
			if ( ev.target && ev.target.closest( '.en_button--disabled' ) && ev.target.closest( '.en_mdl_article_detail__size-choice' ) ) {
				const sizeChoice = ev.target.closest( '.en_mdl_article_detail__size-choice' );
				const sizeChoiceInput = sizeChoice.querySelector( '.acl_js--size_choice_input' );
				const popupEl = document.getElementById( 'popup_alternative_product_per_size' );
				const popupHeadingEl = popupEl.querySelector( '.mdl_popup__heading' );
				const popupProductCarouselEl = popupEl.querySelector( '.mdl_productcarousel' );

				// Set initial heading text on first click
				if( !popupHeadingInitialText ) {
					popupHeadingInitialText = popupHeadingEl.textContent;
				}

				// Get size of clicked size choice
				const size = sizeChoiceInput.dataset.sizeLabel;

				// Get sku of clicked size choice
				const sku = sizeChoiceInput.dataset.sku;

				popupHeadingEl.textContent = popupHeadingInitialText + ' ' + size;

				// Set data attr to append query param to link for certain size
				popupProductCarouselEl.setAttribute( 'data-sizelink', size );

				// Set data attr to get the right products (including same size)
				popupProductCarouselEl.setAttribute( 'data-context', sku );
			}
		} );
	}
}

export function initAlternativeProductPerSize( containerEl ) {
	if ( containerEl ) {
		containerEl.ACL_Alternative_Product_Per_Size ??= new AlternativeProductPerSize( containerEl );
	}
}

$( document ).ready( function() {

	const v_cl = getViewControllerName();

	switch ( v_cl ) {
		case 'details':
			initAlternativeProductPerSize( document.getElementById( 'details_container' ) );
			break;
	}
} );
